import { ScaleTypes } from '../../utils/enum'
import { formatNumberOnUnitMeasure } from '../../utils/helper'
import { COLOR_MAP } from '../../utils/theme'

const ContinuousMapLegend = ({
  min,
  mid,
  max,
  scaleType,
  unitMeasure,
  decimals,
  noDataColor,
}) => {
  let color = COLOR_MAP[`${scaleType.replace(' ', '')}_7`]
  return (
    <div
      className="map-legand-components"
      style={{ padding: '0px 0px 16px 0px' }}
    >
      <div className="map-legand-row">
        <div className="map-legand-label">No data </div>
        {((min !== '' && min !== undefined && min !== null) ||
          (mid !== '' && mid !== undefined && mid !== null) ||
          (max !== '' && max !== undefined && max !== null)) && (
          <div className="map-legand-textrow">
            <div className="map-legand-label">
              {/* format number to K,M,B etc and round off decimals */}
              {min !== '' && min !== undefined && min !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure(min, unitMeasure, decimals)
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(min)
                : ''}
            </div>
            <div className="map-legand-label">
              {/* format number to K,M,B etc and round off decimals */}
              {mid !== '' && mid !== undefined && mid !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure(mid, unitMeasure, decimals)
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(mid)
                : ''}
            </div>
            <div className="map-legand-label">
              {/* format number to K,M,B etc and round off decimals */}
              {max !== '' && max !== undefined && max !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure(max, unitMeasure, decimals)
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(max)
                : ''}
            </div>
          </div>
        )}
      </div>
      <div className="map-legand-row">
        <div className="map-legand-color">
          <div
            className="map-legand line1"
            style={{ background: noDataColor }}
          ></div>
        </div>
        {color && color.length > 0 ? (
          <div className="map-legand-colorline">
            <div
              className="map-legand-line"
              style={{
                background: `linear-gradient(to right,${color[0]} 0%,${color[1]} 17%,${color[2]} 34%,${color[3]} 51%,${color[4]} 68%,${color[5]} 84%,${color[6]} 100%)`,
              }}
            ></div>
          </div>
        ) : (
          console.error('Issue in legend scale')
        )}
      </div>
    </div>
  )
}
export default ContinuousMapLegend
